/**
 * Query params for GET /customers/:id/previous_works.
 *
 * Report page: pass excludeReportId + referenceSystemId (no customerSystemId)
 * so other facilities appear, marked different_facility.
 *
 * Facility page: pass customerSystemId so only that anlegg is listed.
 */
export function previousWorksRequestParams({
  excludeReportId,
  customerSystemId,
  referenceSystemId,
  limit = 12,
} = {}) {
  return {
    limit,
    exclude_report_id: excludeReportId || undefined,
    customer_system_id: customerSystemId || undefined,
    reference_system_id: referenceSystemId || undefined,
  };
}

export function isDifferentFacility(row) {
  if (row?.different_facility === true) return true;
  if (row?.different_facility === false) return false;
  if (row?.same_facility === false) return true;
  return false;
}

export function facilityBadgeLabel(row, differentFacilityText) {
  const name = typeof row?.system_name === "string" ? row.system_name.trim() : "";
  if (!name) return differentFacilityText;
  return `${differentFacilityText}: ${name}`;
}
